import React from 'react';
import PropTypes from 'prop-types';

import { Panel } from 'react-bootstrap';

import ManagedInput from 'components/form/managed_input';

export default function CompanyGridEnabled({ companyGrid, onChange }) {
  return (
    <Panel className="company-grid-enabled-panel">
      <Panel.Body>
        <ManagedInput
          checked={companyGrid.enabled}
          name="enabled"
          type="checkbox"
          onChange={onChange}
        >
          Enable grid template
        </ManagedInput>

        <p>
          When enabled, company users with Grids turned on will be able to select this grid template
          from a listing’s Grids tab.
        </p>
      </Panel.Body>
    </Panel>
  );
}

CompanyGridEnabled.propTypes = {
  companyGrid: PropTypes.shape({
    enabled: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func,
};
